import moment from 'moment';
import React from 'react';
import { Stack, Dialog, DialogContent } from '@mui/material';

import { MicroExperienceManagerProvider } from './Context';
// import { MicroExperienceManagerContext } from './Context';

import CustomerProfile from './ProfilePanel';

import { BorderedPagePanel, TabPanel } from 'Components/Styled.jsx';
import MicroExperienceEditForm from './MicroExperienceEditForm.jsx';
// import MilestonesPanel from './MilestonesPanel.jsx';
// import EventCalendar from './Calendar';
import MicroExperienceList from './MicroExperienceList';
import MicroExperienceBookingsList from './MicroExperienceBookingsList';
import WishList from './WishList';
// import * as CustomerApi from 'Services/CustomerApi';
import { Button, Box, Tabs, Tab, useTheme } from '@mui/material';
import ModalDialogTitle from 'Components/ModalDialogTitle';
import MicroexperienceSelector from './MicroexperienceSelector';
import CardDetailsView from './CardDetailView';
import BundleSelector from './BundleSelector';
import BundleCardDetailView from './BundleCardDetailView';

const tabs = ['MX Engage', 'Wish List', 'Timeline(Old)'];

export default function MicroExperienceDashboard({ customer }) {
    const [displayMode, setDisplayMode] = React.useState('LIST');
    const [activeMX, setActiveMX] = React.useState({});
    const [customerId, setCustomerId] = React.useState(customer?.profile?.id);
    const [addCardVisible, setaddCardVisible] = React.useState(false);
    const theme = useTheme();
    React.useEffect(() => setCustomerId(customer?.profile?.id), [customer]);

    React.useEffect(() => {
        setCustomerId(customer.profile.id)
    }, [customer]);

    // function updatePersonalMilestones({ action, milestone }) {
    //     if (action === 'ADD_MILESTONE') {
    //         CustomerApi.addCustomerMilestone(customer.profile.id, milestone).then((result) => {
    //             console.log({ result });
    //         });
    //     }
    // }

    // function createMicroExperience() {
    //     setDisplayMode('CREATE');
    // }

    function addClicked() {
        setaddCardVisible(true);        
        setDisplayMode('ADD');
        setActiveMX({});
    }

    function handleAddClose() {
        setaddCardVisible(false);
        setDisplayMode('LIST');
    }

    function onAddNewCard(data) {
        (async () => {
            //console.log( data );
            //await addCardToBundle(bundle, data);
            //loadBundle();
            setaddCardVisible(false);
            setDisplayMode('LIST');
        })();
    }

    // function editMicroExperience() {
    //     setDisplayMode('EDIT')
    // }

    const selectedDate = moment().utc();
    // const [selectedDate, setSelectedDate] = React.useState(moment());

    // function milestoneDatePicked(date) {
    //     setSelectedDate(date);
    // }

    // function calendarDatePicked(date) {
    //     setSelectedDate(date);
    // }

    function onSaveMX() {
        setDisplayMode('LIST');
    }

    function onCancelMX() {
        setDisplayMode('LIST');
    }

    //const [hoverOn, setHoverOn] = React.useState(false);

    function onSelectMX(mx) {
        //setDisplayMode('EDIT');
        //setActiveMX(mx); //Get customer MX data and prepare MX/Bundle objects while creating edit feature
        //setaddCardVisible(true);
        console.log("mx", mx)
    }

    function onDeleteMX(mode) {
        setDisplayMode(mode);
    }

    const [selectedTab, setSelectedTab] = React.useState(0);

    if (!customer) {
        console.log('LOADING NO customer')
        return (<>Loading...</>)
    }

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <>
            <MicroExperienceManagerProvider>
                {!!customer && (
                    <React.Fragment>
                        <CustomerProfile customer={customer} />
                        <Tabs value={selectedTab} onChange={handleTabChange}>
                            {tabs.map((tab, index) => (
                                <Tab
                                    key={index}
                                    style={{ textTransform: 'capitalize', color: theme.palette.text.secondary }}
                                    label={tab}
                                />
                            ))}
                        </Tabs>
                        <TabPanel value={selectedTab} index={2}>
                            {
                                {
                                    CREATE: (
                                        <MicroExperienceEditForm
                                            mode="CREATE"
                                            mx={{
                                                customerId: customer.profile.id,
                                            }}
                                            experienceDate={selectedDate}
                                            customer={customer}
                                            seelctedDate={selectedDate}
                                            onSave={onSaveMX}
                                            onCancel={onCancelMX}
                                        />
                                    ),
                                    EDIT: (
                                        <MicroExperienceEditForm
                                            mode="EDIT"
                                            customer={customer}
                                            mx={activeMX}
                                            onSave={onSaveMX}
                                            onCancel={onCancelMX}
                                        />
                                    ),
                                    LIST: (
                                        <BorderedPagePanel>
                                            <Stack direction="row" spacing="2" style={{justifyContent:'flex-end'}}>
                                                <Stack direaction="column" spacing="2">
                                                    <Box sx={{ px: 2 }}>
                                                        <Button
                                                            sx={{
                                                                width: 1,
                                                                marginBottom: '5px',
                                                                fontWeight: 'bold'
                                                            }}
                                                            variant="contained"
                                                            color="primary"
                                                            //onMouseEnter={() => setHoverOn(true)}
                                                            //onMouseLeave={() => setHoverOn(false)}
                                                            onClick={() => {
                                                                //setHoverOn(false);
                                                                //createMicroExperience();
                                                                addClicked();
                                                            }}
                                                        >
                                                            + Add
                                                        </Button>
                                                    </Box>

                                                    {/* <EventCalendar
                                                        isHover={hoverOn}
                                                        customer={customer}
                                                        selectedDate={selectedDate}
                                                        onDatePicked={calendarDatePicked}
                                                    /> */}
                                                </Stack>
                                                {/* <MilestonesPanel
                                                    customer={customer}
                                                    updatePersonalMilestones={updatePersonalMilestones}
                                                    onDatePicked={milestoneDatePicked}
                                                    selectedDate={selectedDate}
                                                /> */}
                                            </Stack>
                                            <MicroExperienceList customerId={customerId} onSelectMX={onSelectMX} onDeleteMX={onDeleteMX} />
                                        </BorderedPagePanel>
                                    ),
                                    RELOAD_LIST: <div></div>,
                                }[displayMode]
                            }
                        </TabPanel>
                        <TabPanel value={selectedTab} index={0}>
                            {
                                {
                                    LIST: (
                                        <BorderedPagePanel>
                                            <MicroExperienceBookingsList
                                                customerId={customerId}
                                                onSelectMX={onSelectMX}
                                                onDeleteMX={onDeleteMX}
                                            />
                                        </BorderedPagePanel>
                                    ),
                                    RELOAD_LIST: <div></div>,
                                }[displayMode]
                            }
                        </TabPanel>
                        <TabPanel value={selectedTab} index={1}>
                            {
                                {
                                    LIST: (
                                        <BorderedPagePanel>
                                            <WishList
                                                customerId={customerId}
                                                onSelectMX={onSelectMX}
                                                onDeleteMX={onDeleteMX}
                                            />
                                        </BorderedPagePanel>
                                    ),
                                    RELOAD_LIST: <div></div>,
                                }[displayMode]
                            }
                        </TabPanel>
                    </React.Fragment>
                )}
                {!customer && <div>No Data</div>}
              {/* <pre>{JSON.stringify(customer, null, 2)}</pre> */}
            </MicroExperienceManagerProvider>
            <Dialog open={addCardVisible} onClose={handleAddClose} fullWidth maxWidth="lg">
                <ModalDialogTitle onClose={handleAddClose}>&nbsp;</ModalDialogTitle>
                <DialogContent style={{ minHeight: '80vh', display: 'flex', flex: 1, maxHeight: '80vh' }}>
                    <AddCardView onSaveCard={onAddNewCard} onClose={handleAddClose} customer={customer} />
                </DialogContent>
            </Dialog>
        </>
    );
}

function AddCardView({ onSaveCard, onClose, customer }) {
    const [cardStep, setCardStep] = React.useState('');
    const [cardType, setCardType] = React.useState('');
    const [selectedObject, setSelectedObject] = React.useState({});

    function onCardTypeSelected(selectedType) {
        setCardStep(selectedType);
        setCardType(selectedType);
    }

    function onCardObjectSelected(mx) {
        setSelectedObject(mx);
    }

    React.useEffect(() => {
        if (selectedObject?.id) {
            setCardStep('NEW_CARD_DETAILS');
        }
    }, [selectedObject]);

    function onBackClicked() {
        setCardStep(cardType);
        setSelectedObject({});
    }

    switch (cardStep) {
        case 'NEW_CARD_DETAILS':
            return (
                cardType === 'MICROEXPERIENCE' ?
                <CardDetailsView
                    card={selectedObject}
                    customer={customer}
                    experienceDate={moment().utc()}
                    onClose={onClose}
                    onSaveCard={onSaveCard}
                    onBackClicked={onBackClicked}
                    cardType={cardType}
                />
                :
                <BundleCardDetailView
                    card={selectedObject}
                    customer={customer}
                    experienceDate={moment().utc()}
                    onClose={onClose}
                    onSaveCard={onSaveCard}
                    onBackClicked={onBackClicked}
                    cardType={cardType}
                />
            );
        case 'BUNDLE':
            return <BundleSelector onCardObjectSelected={onCardObjectSelected} />;
        case 'MICROEXPERIENCE':
            return <MicroexperienceSelector onCardObjectSelected={onCardObjectSelected} />;
        default:
            return <CardTypeSelector onCardTypeSelected={onCardTypeSelected} />;
    }    
}

function CardTypeSelector({ onCardTypeSelected }) {
    return (
        <Stack direction="row" justifyContent="space-between" sx={{ alignSelf: 'centre', margin: 'auto' }} spacing={40}>
            <Button
                variant="contained"
                color="primary"
                onClick={() => onCardTypeSelected('BUNDLE')}
                sx={{ height: 180, width: 180 }}
            >
                Bundle
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={() => onCardTypeSelected('MICROEXPERIENCE')}
                sx={{ height: 180, width: 180 }}
            >
                MicroExperience
            </Button>
        </Stack>
    );
}
